import { LOCATIONS } from 'src/consts';

// NOTE: adding locations here requires adding a corresponding GOOGLE_MAPS_ID_FOR_CAPSULE
// for google maps lookups
export const LOCALE_ID_NAMES = {
  [LOCATIONS.NYC]: 'new-york-city',
  [LOCATIONS.ATL]: 'atlanta',
  [LOCATIONS.AUS]: 'austin',
  [LOCATIONS.BOS]: 'boston',
  [LOCATIONS.CHI]: 'chicago',
  [LOCATIONS.DEN]: 'denver',
  [LOCATIONS.HOU]: 'houston',
  [LOCATIONS.LA]: 'los-angeles',
  [LOCATIONS.MIA]: 'miami',
  [LOCATIONS.NAS]: 'nashville',
  [LOCATIONS.PHL]: 'philadelphia',
  [LOCATIONS.TAM]: 'tampa',
  [LOCATIONS.MSP]: 'minneapolis',
  [LOCATIONS.WDC]: 'washington-dc',
};

export const AVAILABLE_LOCALES = Object.keys(LOCALE_ID_NAMES);

export const Status = {
  DEFAULT: 'DEFAULT',
  SUCCESS: 'SUCCESS',
};

export const ZipcodeCheckerStatus = {
  DEFAULT: 'DEFAULT',
  INVALID: 'INVALID',
};

export const WAITLIST_WRAPPER = 'waitlist-wrapper';

export const ELEMENT_IDS = {
  emailField: 'emailField',
  zipcodeInputField: 'locations_zipcode',
};
